import { Head, useForm } from '@inertiajs/react'
import { HomeMark } from '../../shared/HomeMark.jsx'
import { withSiteFooter } from '../../shared/SiteFooter.jsx'
import { Button } from '../../components/core/Button.jsx'
import { Field } from '../../components/forms/Field.jsx'
import { Input } from '../../components/forms/Input.jsx'

// GET /invitation/:token — accepting an invitation to a complimentary account,
// sent from the admin screen (2026-10-12). Setting a password confirms the
// address and signs in, then the next page is setting up a business.
//
// The hint states the rule the reset page states, which is the rule the model
// enforces: length in `InvitationsController#update`, the rest on `User`.
export default function Invitation({ email = '', token = '', errors = {} }) {
  const form = useForm({ password: '', password_confirmation: '' })

  function submit(e) {
    e.preventDefault()
    form.patch(`/invitation/${token}`)
  }

  return (
    <>
      <Head title="Set your password" />
      <main className="mx-auto flex min-h-screen w-full max-w-md flex-col justify-center gap-8 px-6 py-16">
        <HomeMark />
        <div className="flex flex-col gap-2">
          <h1 className="page-title">Set your password</h1>
          <p className="text-[15px] text-[color:var(--text-body)]">
            Your complimentary account is ready for {email}. Choose a password and the next step is
            adding the business to measure.
          </p>
        </div>

        <form onSubmit={submit} className="flex flex-col gap-5">
          <Field label="Password" htmlFor="password" required hint="At least 8 characters, including a number and a symbol." error={errors.password}>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              value={form.data.password}
              invalid={Boolean(errors.password)}
              onChange={(e) => form.setData('password', e.target.value)}
            />
          </Field>

          <Field label="Confirm password" htmlFor="password_confirmation" required error={errors.password_confirmation}>
            <Input
              id="password_confirmation"
              name="password_confirmation"
              type="password"
              autoComplete="new-password"
              value={form.data.password_confirmation}
              invalid={Boolean(errors.password_confirmation)}
              onChange={(e) => form.setData('password_confirmation', e.target.value)}
            />
          </Field>

          <Button variant="primary" size="lg" block as="button" loading={form.processing}>
            Set the password
          </Button>
        </form>
      </main>
    </>
  )
}

Invitation.layout = withSiteFooter
